import Root from './ui/root/Root';
import Body from './ui/body/Body';
import Footer from './ui/footer/Footer';
import Header from './ui/header/Header';

export const CardDesign = Object.assign(Root, {
  Header,
  Body,
  Footer,
});
